import { render } from "./PetGame.vue?vue&type=template&id=0c86be71&scoped=true"
import script from "./PetGame.vue?vue&type=script&lang=js"
export * from "./PetGame.vue?vue&type=script&lang=js"

import "./PetGame.vue?vue&type=style&index=0&id=0c86be71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c86be71"]])

export default __exports__